import React from 'react';
import classnames from 'classnames';
import shortenNumber from '@wix/da-shared-react/pkg/utils/shortenNumber';
import { BiDataHook } from '@wix/da-shared-react/pkg/biLogger';

import s from './WidgetHeader.scss';

export interface Props {
  header?: string | React.ReactNode;
  count?: number | string;
  className?: string;
  extras?: React.ReactNode | React.ReactNode[];
}

const WidgetHeader: React.FC<Props> = ({
  header,
  count,
  className,
  extras,
}) => (
  <div className={classnames(s['root'], className)}>
    {header && (
      <h2 className={s['header']} data-hook={BiDataHook.WIDGET_HEADER}>
        {header}
        {!!count && (
          <span
            className={s['count']}
            data-hook={BiDataHook.WIDGET_HEADER_COUNTER}
          >
            {shortenNumber(count)}
          </span>
        )}
      </h2>
    )}
    {extras}
  </div>
);
WidgetHeader.displayName = 'WidgetHeader';

export default WidgetHeader;
